import AuthFailedComponent from './AuthFailedLoginComponent';

export default AuthFailedComponent